import { useAgent } from '@getdutchie/agent-react';

const IDLE_STATUSES = ['', 'Ready'];

export function useAgentStatus() {
  const { status, messages, error } = useAgent();

  const lastMessage = messages[messages.length - 1];
  const isWaitingForReply = lastMessage?.role === 'user' && !error;
  const isIdle = IDLE_STATUSES.includes(status) && !isWaitingForReply;
  const statusLabel = IDLE_STATUSES.includes(status) ? 'Thinking...' : status;

  return { status, statusLabel, isIdle };
}
